/* unplugin-vue-components disabled */import { render } from "./positionDetail.vue?vue&type=template&id=be5df0a6&scoped=true"
import script from "./positionDetail.vue?vue&type=script&lang=js"
export * from "./positionDetail.vue?vue&type=script&lang=js"

import "./positionDetail.vue?vue&type=style&index=0&id=be5df0a6&lang=less&scoped=true"

import exportComponent from "/Users/yfy/work/work/cms-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-be5df0a6"]])

export default __exports__